import List from './list/index.vue'
import Student from './student/index.vue'
import Class from './class/index.vue'
export default {
  List,
  Student,
  Class
}
